import styled from 'styled-components';
import { useMsal } from '@azure/msal-react';
import { Link } from 'react-router-dom';
import logoSrc from '../../assets/images/se-logo.png';
import { ReactComponent as UserSvg } from '../../assets/svg/fa-circle-user.svg';
import { ReactComponent as LogoutSvg } from '../../assets/svg/fa-arrow-right-from-bracket.svg';
import Navigation from './navigation';
import { HOME } from '../../config/routes';

const UserIcon = styled(UserSvg)`
  width: 18px;
  height: auto;
  fill: ${({ theme }) => theme.colors.text_dark};
`;

const LogoutIcon = styled(LogoutSvg)`
  width: 18px;
  height: auto;
  fill: ${({ theme }) => theme.colors.text_dark};
  cursor: pointer;

  &:hover {
    fill: ${({ theme }) => theme.colors.link_hover};
  }
`;

const Logo = styled.img`
  width: 4.5rem;
  height: auto;
`;

const Wrapper = styled.div`
  /* border-top: 2px solid ${({ theme }) => theme.colors.brand_yellow}; */
  border-bottom: 1px solid ${({ theme }) => theme.colors.bg_gray};
  /* margin-bottom: 2rem; */
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* min-height: 3.5em; */
  height: 96px;
  padding-left: 1rem;
  padding-right: 1rem;
  max-width: 1920px;
  margin: 0 auto;

  p {
    margin: 0;
  }
`;

const MainNav = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-items: stretch;
  height: 100%;
`;

const RightNav = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 6px;
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem;

  ${Logo} {
    width: 3.5rem;
    margin-right: 2rem;
  }

  a {
    display: inline-flex;
    align-items: center;
  }

  h1 {
    font-size: 1.125rem;
    font-weight: 600;
    margin: 0;
    margin-right: 1.5rem;
  }
`;

const ProfileName = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  ${UserIcon} {
    margin-right: 8px;
  }

  span {
    display: block;
  }
`;

const ProfileLink = styled(Link)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  color: ${({ theme }) => theme.colors.text_dark};

  &:hover {
    color: ${({ theme }) => theme.colors.link_hover};

    ${UserIcon} {
      fill: ${({ theme }) => theme.colors.link_hover};
    }
  }

  span {
    display: none;
  }

  @media screen and (min-width: 576px) {
    ${UserIcon} {
      margin-right: 8px;
    }

    span {
      display: block;
    }
  }
`;

const Divider = styled.span`
  margin: 0 16px;
`;

const ProfileActions = styled.div`
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-end;
`;

function Header() {
  const { instance, accounts } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  return (
    <Wrapper>
      <ContentWrapper>
        <MainNav>
          <LogoWrapper>
            <Link to={HOME}>
              <Logo src={logoSrc} alt="The renewable materials company" />
              <h1>Energy Monitoring tool</h1>
            </Link>
          </LogoWrapper>
          <Navigation />
        </MainNav>
        <RightNav>
          <ProfileActions>
            <ProfileName>
              {/* <ProfileLink to="/"> */}
              <UserIcon />
              <span>{accounts[0].name}</span>
              {/* </ProfileLink> */}
            </ProfileName>
            <Divider>|</Divider>
            <LogoutIcon onClick={handleLogout} />
          </ProfileActions>
        </RightNav>
      </ContentWrapper>
    </Wrapper>
  );
}

export default Header;
